const QUOTA_ERROR_MESSAGES = new Set([
    "User has reached the limit of characters generated",
    "User has reached the limit of characters generated.",
    "user-has-reached-the-limit-of-characters-generated",
]);

export const isQuotaError = (error: unknown): boolean => {
    const err = error as { details?: { message?: unknown }; message?: unknown } | null | undefined;
    const message = err?.details?.message ?? err?.message;
    return typeof message === "string" && QUOTA_ERROR_MESSAGES.has(message);
};
